import { isHourlyValue } from "../components/date-time-picker/date_time_picker";
import {
  BookingEventStep,
  EventBookingContainerValue,
  EventStep,
} from "../components/event_and_layout/event_booking_container";

export function getEventSteps(value: EventBookingContainerValue): EventStep[] {
  const defaultEventSteps: EventStep[] = [
    {
      stepNumber: BookingEventStep.SelectEvent,
      title: "Select your event",
      isActive: true,
      isDone: false,
    },
    {
      stepNumber: BookingEventStep.SelectSpaceLayout,
      title: "Select your space layout",
      isActive: false,
      isDone: false,
    },
    {
      stepNumber: BookingEventStep.EnterNumberOfGuests,
      title: "Enter your expected number of guests",
      isActive: false,
      isDone: false,
    },
    {
      stepNumber: BookingEventStep.SelectWhenToHost,
      title: "Select when you want to host an event",
      isActive: false,
      isDone: false,
    },
  ];

  const hasEventTypeValue = !!value.eventTypeID;

  const hasLayoutIdValue = !!value.layoutID;

  const hasNumberOfGuestsValue = !!value.attendees;

  const hasDateTimeValue =
    isHourlyValue(value.dateRange) &&
    value.dateRange.startTime &&
    value.dateRange.endTime;

  const hasDateRangeValue =
    !isHourlyValue(value.dateRange) &&
    value.dateRange?.startDate &&
    value.dateRange.endDate;

  if (
    hasEventTypeValue &&
    hasLayoutIdValue &&
    hasNumberOfGuestsValue &&
    (hasDateTimeValue || hasDateRangeValue)
  ) {
    return defaultEventSteps.map((eS) => ({
      ...eS,
      isDone: true,
      isActive: false,
    }));
  } else if (hasEventTypeValue && hasLayoutIdValue && hasNumberOfGuestsValue) {
    return defaultEventSteps.map((eS) => ({
      ...eS,
      isDone: eS.stepNumber < BookingEventStep.SelectWhenToHost,
      isActive: eS.stepNumber === BookingEventStep.SelectWhenToHost,
    }));
  } else if (hasEventTypeValue && hasLayoutIdValue) {
    return defaultEventSteps.map((eS) => ({
      ...eS,
      isDone: eS.stepNumber < BookingEventStep.EnterNumberOfGuests,
      isActive: eS.stepNumber === BookingEventStep.EnterNumberOfGuests,
    }));
  } else if (hasEventTypeValue) {
    return defaultEventSteps.map((eS) => ({
      ...eS,
      isDone: eS.stepNumber === BookingEventStep.SelectEvent,
      isActive: eS.stepNumber === BookingEventStep.SelectSpaceLayout,
    }));
  } else {
    return defaultEventSteps;
  }
}
